import ResolvePagination from './ResolvePagination.component';

export default ResolvePagination;